import { Component, OnDestroy, OnInit, Sanitizer } from '@angular/core';
import { NavParams, ModalController, Platform } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { LanguageService } from 'src/app/services/language.service';
import { DataService } from 'src/app/services/data.service';
import { VimeoService } from 'src/app/services/vimeo.service';

@Component({
    selector: 'app-videomodal',
    templateUrl: './videomodal.component.html',
    styleUrls: ['./videomodal.component.scss'],
    standalone: false
})
export class VideomodalComponent implements OnInit, OnDestroy {
  // private readonly testFullscreenVideoUrl = 'https://player.vimeo.com/video/76979871?dnt=1&playsinline=1&fullscreen=1';
  private readonly defaultVimeoVideoPath = '/407508746';
  
  video: any;

  public response:any;
  public basepath:any;
  public redirecturl:any;
  public vimeolink:any;
  public showAjaxRequestLoader = false;
  public showSpinnerLoader = false;
  private iframeHasLoaded = false;
  private loaderFallbackTimeout: ReturnType<typeof setTimeout> | null = null;
  private readonly loaderFallbackMs = 8000;
  public timeoutIframeload: ReturnType<typeof setTimeout> | null = null;
  public fixedWidth: any = 380;
  private vimeoPlayer: ReturnType<VimeoService['initPlayer']> | null = null;


  constructor(public platform: Platform, public data: DataService, navParams: NavParams, public modalController: ModalController, public sanitizer: DomSanitizer, private languageService: LanguageService, private vimeoService: VimeoService) {

    // if web
  }

  ngOnInit() {
    console.log(this.video)
    this.vimeolink = this.sanitizer.bypassSecurityTrustResourceUrl(this.buildVimeoPlayerUrl());
  }

  get isMobileLayout(): boolean {
    return typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
  }

  ionViewWillEnter() {
    if (this.iframeHasLoaded) {
      return;
    }
    this.showAjaxRequestLoader = true;
    this.clearLoaderFallback();
    this.loaderFallbackTimeout = setTimeout(() => this.dismissLoader(), this.loaderFallbackMs);

    if (this.timeoutIframeload) {
      clearTimeout(this.timeoutIframeload);
    }
    this.timeoutIframeload = setTimeout(() => {
      this.showSpinnerLoader = true;
    }, 5000);
  }

  ngOnDestroy() {
    this.dismissLoader();
    this.vimeoPlayer = null;
    void this.vimeoService.stopCurrentPlayer();
  }

  iframeLoaded(event: Event) {
    this.iframeHasLoaded = true;
    this.dismissLoader();
    this.bindVimeoPlayer(event.target as HTMLIFrameElement);
  }

  private bindVimeoPlayer(iframe: HTMLIFrameElement | null): void {
    if (!iframe) {
      return;
    }
    const src = iframe.getAttribute('src');
    if (!src?.includes('vimeo.com')) {
      return;
    }
    try {
      this.vimeoPlayer = this.vimeoService.initPlayer(iframe);
    } catch (error) {
      console.error('VideomodalComponent: Error initializing Vimeo player:', error);
    }
  }

  private dismissLoader() {
    if (this.timeoutIframeload) {
      clearTimeout(this.timeoutIframeload);
      this.timeoutIframeload = null;
    }
    this.clearLoaderFallback();
    this.showAjaxRequestLoader = false;
    this.showSpinnerLoader = false;
  }

  private clearLoaderFallback() {
    if (this.loaderFallbackTimeout) {
      clearTimeout(this.loaderFallbackTimeout);
      this.loaderFallbackTimeout = null;
    }
  }

  private get videoRatio(): number {
    if (this.video?.width && this.video?.height && this.video.width > 0 && this.video.height > 0) {
      return this.video.width / this.video.height;
    }
    return 16 / 9; // default: landscape 16:9
  }

  platformWidth(): number {
    const ratio = this.videoRatio;
    if (ratio >= 1) {
      // Landscape: cap at 550px, shrink on narrow screens (32px total margin)
      return Math.min(window.innerWidth - 32, 550);
    } else {
      // Portrait: derive from height
      return Math.round(this.platformHeight() * ratio);
    }
  }

  platformHeight(): number {
    const ratio = this.videoRatio;
    if (ratio >= 1) {
      // Landscape: height derived from width
      return Math.round(this.platformWidth() / ratio);
    } else {
      // Portrait: cap at available height
      return Math.min(window.innerHeight - 100, 480);
    }
  }

  vimeowidth(): number {
    return this.platformWidth();
  }

  vimeoheight(): number {
    return this.platformHeight();
  }

  get isNativeIosApp(): boolean {
    return this.platform.is('ios') && this.platform.is('hybrid');
  }

  private buildVimeoPlayerUrl(): string {
    const rawVideoPath = this.video?.vimeovideo;
    const normalizedVideoPath = rawVideoPath
      ? (rawVideoPath.startsWith('/') ? rawVideoPath : `/${rawVideoPath}`)
      : this.defaultVimeoVideoPath;
    const url = new URL(`https://player.vimeo.com/video${normalizedVideoPath}`);
    const extraParams = this.video?.extra_params;

    if (extraParams) {
      const normalizedExtraParams = extraParams.startsWith('?') || extraParams.startsWith('&')
        ? extraParams.slice(1)
        : extraParams;

      new URLSearchParams(normalizedExtraParams).forEach((value, key) => {
        url.searchParams.set(key, value);
      });
    }

    url.searchParams.set('dnt', '1');
    url.searchParams.set('playsinline', '1');
    url.searchParams.set('fullscreen', '1');
    if (this.languageService.currentLang === 'cy') {
      url.searchParams.set('audiotrack', 'cy');
    } else {
      url.searchParams.delete('audiotrack');
    }

    return url.toString();
  }

  get vimeolink_(){
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.buildVimeoPlayerUrl());
  }

  cancel(){
    console.log(this.data.diag)
    this.modalController.dismiss();
    // this.data.rateApp();
  }
}
